<mat-card class="mx-2 mat-elevation-z6 mb-3">
<mat-card-content class="d-flex justify-content-center">
    <mat-icon class="me-2">blur_off</mat-icon>
    <h3>{{'Common.NoData' | translate}}</h3>
</mat-card-content>
</mat-card>